export const USE_RESIZABLE_DIRECTION = {
  Horizontal: 'Horizontal',
  Vertical: 'Vertical',
}
